<template>
  <div>
    <div class="worksTimeOpen" v-show="info">
      <div class="box">
        <p>{{numOne}}</p>
        <p>占比最多</p>
      </div>
      <div class="chart_1" ref="chart"></div>
      <div class="chart_2">
        <div class="list" v-for="(item,index) in list">
          <div class="left">
            <div :style="`width: 10px;height: 10px; background-color: ${color[index]};`"></div> 
            <span style="margin-left: 5px;">{{item.name}}</span>
          </div>
          <div class="right">
            {{ item.works }}%
          </div>
        </div>
      </div>
    </div>
    <div v-show="!info" class="chart">
      <none-data :height="3.5" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dayNum: Number,
    onlySales: Boolean,
  },
  data() {
    return {
      info: true,
      color:['#2877FF','#54AAFF','#7DC2FF','#A6D8FF','#CFECFF','#E4F0FE'],
      list:[],
      numOne:''
    };
  },
  mounted() {
    this.getworksTimeOpen();
  },
  computed: {},
  watch: {
    dayNum: {
      handler() {
        this.getworksTimeOpen();
      },
    },
    onlySales: {
      handler() {
        this.getworksTimeOpen();
      },
    },
  },
  methods: {
    getworksTimeOpen() {
      this.$get({
        road: "opusDuration",
        data: { anchorId: this.$route.params.id },
        params: {
          mode:'daily'
        },
        version: "v2",
      })
        .then((res) => {
          this.info = res.length
          const num = res.reduce((val, item) => val + item.opus, 0);
          const arr = res.map((item,index) => {
            return {value:item.opus,name:item.desc,works: ((item.opus / num) * 100).toFixed(1),color:this.color[index]}
          })
          this.list = arr
          this.numOne=arr.map((val)=>({value:val.value,name:val.name})).sort((a, b) => b.value - a.value).slice().splice(0,1)[0].name//排序取前4
          this.drawChart(arr);
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
    // 字体适配
    FontChart(res) {
      //获取到屏幕的宽度
      var clientWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      if (!clientWidth) return; //报错拦截：
      let fontSize = 10 * (clientWidth / 1920);
      return res * fontSize;
    },
    drawChart(info) {
      echarts.init(this.$refs.chart).setOption({
        color: this.color,
        tooltip: {
          trigger: 'item',
          axisPointer: { type: 'shadow' },
          formatter: val => {
           const item = val.data
            return `<div style="font-family: number-bold;">
            <div style="display:flex;align-items: center;">
              <span style="font-size:14px;color:#252E39;margin-right:6px">发布时间占比</span>
            </div>
            <div style="display:flex;align-items: center;">
              <div style="width: 8px;height: 8px;background: ${item.color};margin-right: 5px;"></div>
              <span style="font-size:12px;color:#696D75;margin-right:16px">${item.name}</span><span style="font-size:14px;color:#4a4a4a;">${item.works}%</span>
            </div>
                  </div>`;
          }
        },
        series: [
          {
            type: "pie",
            radius: ["60%", "90%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 2,
              emphasis: {
                shadowBlur: 10,
                // shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: info,

          },
        ],
        grid: {
          left: 0,
          top: 0,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.worksTimeOpen {
  font-family: number-bold;
  margin-top: 0.24rem;
  width: 7rem;
  height: 3.5rem;
  display: flex;
  position: relative;
  .box {
    position: absolute;
    left:25%;
    top:50%;
    transform: translate(-50%,-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 12px;
    line-height: 18px;
  }
  .chart_1,
  .chart_2 {
    flex: 1;
  }
  .chart_2 {
    display: flex;
    flex-direction: column;
    .list {
      flex:1;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      .left {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #4a4a4a;
      }
      .right {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #4a4a4a;
      }
    }
  }
}
</style>
